import './NotFoundPage.scss'
import React from 'react'
import { Image } from 'semantic-ui-react'
import logo from 'assets/images/RDP.png'
import history from 'services/history'

export default function NotFoundPage() {
    const { location: { state: { path } } } = history
    return (
        <div id="not-found" className='d-flex flex-grow-1 flex-column'>
            <div className="info">
                <h2 className='mt-0'>404 - Página não encontrada</h2>
                {path && <p>A url {path} não existe.</p>}
            </div>
            <Image className='logo' size='small' rounded src={logo} />
        </div>
    )
}
